var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { height: "90vh", width: "810px" },
      model: {
        value: _vm.autoWeekModel,
        callback: function ($$v) {
          _vm.autoWeekModel = $$v
        },
        expression: "autoWeekModel",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticStyle: { "justify-content": "center" } },
                [
                  _c("div", { attrs: { align: "center" } }, [
                    !_vm.saveMode
                      ? _c("h1", [_vm._v(_vm._s(_vm.$t("newAutoWeeklyModel")))])
                      : _c("h1", [
                          _vm._v(_vm._s(_vm.$t("editAutoWeeklyModel"))),
                        ]),
                  ]),
                ]
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "ma-0 px-0 pt-0 pd-2",
                      attrs: { "justify-space-between": "", row: "" },
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { grow: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              counter: 50,
                              label: _vm.$t("weeklyModelName"),
                              rules: _vm.nameRules,
                              disabled: _vm.WeekModel.locked,
                              required: "",
                            },
                            model: {
                              value: _vm.WeekModel.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.WeekModel, "name", $$v)
                              },
                              expression: "WeekModel.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "d-flex justify-space-around",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "width: 100px" },
                        [
                          _c("DatePicker", {
                            attrs: {
                              date: _vm.WeekModel.validFrom,
                              maxDate: _vm.WeekModel.validUntil,
                              label: _vm.$t("validFrom"),
                            },
                            on: {
                              dateChange: function ($event) {
                                ;(_vm.WeekModel.validFrom = $event),
                                  _vm.springToUntilDate()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "width: 100px" },
                        [
                          _c("DatePicker", {
                            key: _vm.counter,
                            ref: "endDate",
                            attrs: {
                              date: _vm.WeekModel.validUntil,
                              minDate: _vm.WeekModel.validFrom,
                              triggerClick: _vm.triggerClick,
                              label: _vm.$t("validUntil"),
                            },
                            on: {
                              dateChange: function ($event) {
                                _vm.WeekModel.validUntil = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.WeekModel.validFrom != null &&
                  _vm.WeekModel.validUntil != null
                    ? _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.groups, function (item) {
                          return _c(
                            "v-list-group",
                            {
                              key: item.id,
                              staticClass: "mb-2",
                              staticStyle: {
                                border: "1px solid gray",
                                "border-radius": "5px",
                              },
                              attrs: { "no-action": "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex justify-space-between",
                                                },
                                                [
                                                  _c("h3", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "excludePeriods"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pl-2" },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _vm.WeekModel.validFrom != null &&
                                          _vm.WeekModel.validUntil != null
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass:
                                                    "d-flex justify-center",
                                                  attrs: { "no-gutters": "" },
                                                },
                                                [
                                                  _c("v-data-table", {
                                                    staticClass: "elevation-1",
                                                    staticStyle: {
                                                      width: "450px",
                                                    },
                                                    attrs: {
                                                      items:
                                                        _vm.WeekModel
                                                          .exclusionPeriods,
                                                      headers: _vm.headers,
                                                      "hide-default-footer": "",
                                                      "items-per-page": 100,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "body",
                                                          fn: function ({
                                                            items,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "tbody",
                                                                _vm._l(
                                                                  items,
                                                                  function (
                                                                    item,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "tr",
                                                                      {
                                                                        key: item.Code,
                                                                        style:
                                                                          _vm.setStyle(
                                                                            item
                                                                          ),
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              _vm.selectedLineIndex =
                                                                                index
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            item.new
                                                                              ? _c(
                                                                                  "v-row",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        justify:
                                                                                          "end",
                                                                                        "no-gutters":
                                                                                          "",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        style:
                                                                                          {
                                                                                            cursor:
                                                                                              "pointer",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.addNewExclusionPeriod(
                                                                                                index
                                                                                              ),
                                                                                                _vm.checkIfExclusionPeriodsOverlap()
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-plus"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _c(
                                                                              "v-row",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex justify-space-around",
                                                                                attrs:
                                                                                  {
                                                                                    justify:
                                                                                      "center",
                                                                                    "no-gutters":
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "v-menu",
                                                                                      {
                                                                                        ref: "exclFromDate",
                                                                                        refInFor: true,
                                                                                        attrs:
                                                                                          {
                                                                                            "v-model":
                                                                                              _vm.startMenu,
                                                                                            "close-on-content-click": true,
                                                                                            "offset-x":
                                                                                              "",
                                                                                          },
                                                                                        scopedSlots:
                                                                                          _vm._u(
                                                                                            [
                                                                                              {
                                                                                                key: "activator",
                                                                                                fn: function ({
                                                                                                  on: menu,
                                                                                                  attrs,
                                                                                                }) {
                                                                                                  return [
                                                                                                    _c(
                                                                                                      "h3",
                                                                                                      _vm._g(
                                                                                                        _vm._b(
                                                                                                          {
                                                                                                            style:
                                                                                                              {
                                                                                                                cursor:
                                                                                                                  "pointer",
                                                                                                              },
                                                                                                          },
                                                                                                          "h3",
                                                                                                          attrs,
                                                                                                          false
                                                                                                        ),
                                                                                                        menu
                                                                                                      ),
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm.formattedDate(
                                                                                                                item.fromDate
                                                                                                              )
                                                                                                            ) +
                                                                                                            " "
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ]
                                                                                                },
                                                                                              },
                                                                                            ],
                                                                                            null,
                                                                                            true
                                                                                          ),
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-card",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                tile: "",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-date-picker",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    min: _vm
                                                                                                      .WeekModel
                                                                                                      .validFrom,
                                                                                                    max: _vm
                                                                                                      .WeekModel
                                                                                                      .validUntil,
                                                                                                    "first-day-of-week": 1,
                                                                                                    scrollable:
                                                                                                      "",
                                                                                                    flat: "",
                                                                                                    format:
                                                                                                      "24hr",
                                                                                                  },
                                                                                                on: {
                                                                                                  change:
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      _vm.checkIfExclusionPeriodsOverlap(),
                                                                                                        _vm.springToExclUntilDate(
                                                                                                          index,
                                                                                                          item
                                                                                                        )
                                                                                                    },
                                                                                                  input:
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      _vm.timeField =
                                                                                                        item.fromDate
                                                                                                    },
                                                                                                },
                                                                                                model:
                                                                                                  {
                                                                                                    value:
                                                                                                      item.fromDate,
                                                                                                    callback:
                                                                                                      function (
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          item,
                                                                                                          "fromDate",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                    expression:
                                                                                                      "item.fromDate",
                                                                                                  },
                                                                                              }
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _c(
                                                                              "v-row",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex justify-space-around",
                                                                                attrs:
                                                                                  {
                                                                                    justify:
                                                                                      "center",
                                                                                    "no-gutters":
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "v-menu",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            "v-model":
                                                                                              _vm.endMenu,
                                                                                            "close-on-content-click": true,
                                                                                            "offset-x":
                                                                                              "",
                                                                                          },
                                                                                        scopedSlots:
                                                                                          _vm._u(
                                                                                            [
                                                                                              {
                                                                                                key: "activator",
                                                                                                fn: function ({
                                                                                                  on: menu,
                                                                                                  attrs,
                                                                                                }) {
                                                                                                  return [
                                                                                                    _c(
                                                                                                      "h3",
                                                                                                      _vm._g(
                                                                                                        _vm._b(
                                                                                                          {
                                                                                                            ref: "exclToDate",
                                                                                                            refInFor: true,
                                                                                                            style:
                                                                                                              {
                                                                                                                cursor:
                                                                                                                  "pointer",
                                                                                                              },
                                                                                                          },
                                                                                                          "h3",
                                                                                                          attrs,
                                                                                                          false
                                                                                                        ),
                                                                                                        menu
                                                                                                      ),
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm.formattedDate(
                                                                                                                item.toDate
                                                                                                              )
                                                                                                            ) +
                                                                                                            " "
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ]
                                                                                                },
                                                                                              },
                                                                                            ],
                                                                                            null,
                                                                                            true
                                                                                          ),
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-card",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                tile: "",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-date-picker",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    min: _vm
                                                                                                      .WeekModel
                                                                                                      .validFrom,
                                                                                                    max: _vm
                                                                                                      .WeekModel
                                                                                                      .validUntil,
                                                                                                    "first-day-of-week": 1,
                                                                                                    scrollable:
                                                                                                      "",
                                                                                                    flat: "",
                                                                                                    format:
                                                                                                      "24hr",
                                                                                                  },
                                                                                                on: {
                                                                                                  input:
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      _vm.timeField =
                                                                                                        item.toDate
                                                                                                    },
                                                                                                  change:
                                                                                                    function (
                                                                                                      $event
                                                                                                    ) {
                                                                                                      _vm.addNewExclusionPeriod(
                                                                                                        index
                                                                                                      ),
                                                                                                        _vm.checkIfExclusionPeriodsOverlap()
                                                                                                    },
                                                                                                },
                                                                                                model:
                                                                                                  {
                                                                                                    value:
                                                                                                      item.toDate,
                                                                                                    callback:
                                                                                                      function (
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          item,
                                                                                                          "toDate",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                    expression:
                                                                                                      "item.toDate",
                                                                                                  },
                                                                                              }
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            !item.new
                                                                              ? _c(
                                                                                  "v-row",
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        style:
                                                                                          {
                                                                                            cursor:
                                                                                              "pointer",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.deleteExclusionPeriod(
                                                                                                index
                                                                                              ),
                                                                                                _vm.checkIfExclusionPeriodsOverlap()
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-delete"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.WeekModel.validFrom != null &&
                  _vm.WeekModel.validUntil != null
                    ? _c(
                        "v-layout",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { "justify-space-between": "", column: "" },
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    staticStyle: { "max-width": "460px" },
                                    attrs: {
                                      label: _vm.$t("monday"),
                                      readonly: "",
                                      disabled: _vm.WeekModel.locked,
                                      "append-icon": "mdi-pencil",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showAutoDailyModel = true
                                        _vm.selectedDay = "monday"
                                      },
                                    },
                                    model: {
                                      value: _vm.WeekModel.monday.workTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.monday,
                                          "workTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.monday.workTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.rhythmTypes,
                                      disabled: _vm.WeekModel.locked,
                                    },
                                    model: {
                                      value: _vm.WeekModel.monday.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.monday,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.monday.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.WeekModel.monday.type != 0
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _vm.WeekModel.validFrom != null &&
                                      _vm.WeekModel.validUntil != null
                                        ? _c("DatePicker", {
                                            key: _vm.WeekModel.monday.startDate,
                                            attrs: {
                                              date: _vm.WeekModel.monday
                                                .startDate,
                                              minDate: _vm.WeekModel.validFrom,
                                              maxDate: _vm.WeekModel.validUntil,
                                              label: _vm.$t("firstBookingDate"),
                                              allowedDates: _vm.allowedDates,
                                              disabled: _vm.WeekModel.locked,
                                            },
                                            on: {
                                              dateChange: function ($event) {
                                                _vm.WeekModel.monday.startDate =
                                                  $event
                                              },
                                              monthChanged: function ($event) {
                                                return _vm.setAllowedDates(
                                                  1,
                                                  _vm.WeekModel.monday.type,
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    staticStyle: { "max-width": "460px" },
                                    attrs: {
                                      label: _vm.$t("tuesday"),
                                      readonly: "",
                                      disabled: _vm.WeekModel.locked,
                                      "append-icon": "mdi-pencil",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showAutoDailyModel = true
                                        _vm.selectedDay = "tuesday"
                                      },
                                    },
                                    model: {
                                      value: _vm.WeekModel.tuesday.workTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.tuesday,
                                          "workTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.tuesday.workTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.rhythmTypes,
                                      disabled: _vm.WeekModel.locked,
                                    },
                                    model: {
                                      value: _vm.WeekModel.tuesday.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.tuesday,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.tuesday.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.WeekModel.tuesday.type != 0
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("DatePicker", {
                                        key: _vm.WeekModel.tuesday.startDate,
                                        attrs: {
                                          date: _vm.WeekModel.tuesday.startDate,
                                          minDate: _vm.WeekModel.validFrom,
                                          maxDate: _vm.WeekModel.validUntil,
                                          label: _vm.$t("firstBookingDate"),
                                          allowedDates: _vm.allowedDates,
                                          disabled: _vm.WeekModel.locked,
                                        },
                                        on: {
                                          dateChange: function ($event) {
                                            _vm.WeekModel.tuesday.startDate =
                                              $event
                                          },
                                          monthChanged: function ($event) {
                                            return _vm.setAllowedDates(
                                              2,
                                              _vm.WeekModel.tuesday.type,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    staticStyle: { "max-width": "460px" },
                                    attrs: {
                                      label: _vm.$t("wednesday"),
                                      readonly: "",
                                      disabled: _vm.WeekModel.locked,
                                      "append-icon": "mdi-pencil",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showAutoDailyModel = true
                                        _vm.selectedDay = "wednesday"
                                      },
                                    },
                                    model: {
                                      value: _vm.WeekModel.wednesday.workTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.wednesday,
                                          "workTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "WeekModel.wednesday.workTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.rhythmTypes,
                                      disabled: _vm.WeekModel.locked,
                                    },
                                    model: {
                                      value: _vm.WeekModel.wednesday.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.wednesday,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.wednesday.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.WeekModel.wednesday.type != 0
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("DatePicker", {
                                        key: _vm.WeekModel.wednesday.startDate,
                                        attrs: {
                                          date: _vm.WeekModel.wednesday
                                            .startDate,
                                          minDate: _vm.WeekModel.validFrom,
                                          maxDate: _vm.WeekModel.validUntil,
                                          label: _vm.$t("firstBookingDate"),
                                          allowedDates: _vm.allowedDates,
                                          disabled: _vm.WeekModel.locked,
                                        },
                                        on: {
                                          dateChange: function ($event) {
                                            _vm.WeekModel.wednesday.startDate =
                                              $event
                                          },
                                          monthChanged: function ($event) {
                                            return _vm.setAllowedDates(
                                              3,
                                              _vm.WeekModel.wednesday.type,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    staticStyle: { "max-width": "460px" },
                                    attrs: {
                                      label: _vm.$t("thursday"),
                                      readonly: "",
                                      disabled: _vm.WeekModel.locked,
                                      "append-icon": "mdi-pencil",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showAutoDailyModel = true
                                        _vm.selectedDay = "thursday"
                                      },
                                    },
                                    model: {
                                      value: _vm.WeekModel.thursday.workTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.thursday,
                                          "workTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.thursday.workTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.rhythmTypes,
                                      disabled: _vm.WeekModel.locked,
                                    },
                                    model: {
                                      value: _vm.WeekModel.thursday.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.thursday,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.thursday.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.WeekModel.thursday.type != 0
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("DatePicker", {
                                        key: _vm.WeekModel.thursday.startDate,
                                        attrs: {
                                          date: _vm.WeekModel.thursday
                                            .startDate,
                                          minDate: _vm.WeekModel.validFrom,
                                          maxDate: _vm.WeekModel.validUntil,
                                          label: _vm.$t("firstBookingDate"),
                                          allowedDates: _vm.allowedDates,
                                          disabled: _vm.WeekModel.locked,
                                        },
                                        on: {
                                          dateChange: function ($event) {
                                            _vm.WeekModel.thursday.startDate =
                                              $event
                                          },
                                          monthChanged: function ($event) {
                                            return _vm.setAllowedDates(
                                              4,
                                              _vm.WeekModel.thursday.type,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    staticStyle: { "max-width": "460px" },
                                    attrs: {
                                      label: _vm.$t("friday"),
                                      readonly: "",
                                      disabled: _vm.WeekModel.locked,
                                      "append-icon": "mdi-pencil",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showAutoDailyModel = true
                                        _vm.selectedDay = "friday"
                                      },
                                    },
                                    model: {
                                      value: _vm.WeekModel.friday.workTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.friday,
                                          "workTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.friday.workTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.rhythmTypes,
                                      disabled: _vm.WeekModel.locked,
                                    },
                                    model: {
                                      value: _vm.WeekModel.friday.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.friday,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.friday.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.WeekModel.friday.type != 0
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("DatePicker", {
                                        key: _vm.WeekModel.friday.startDate,
                                        attrs: {
                                          date: _vm.WeekModel.friday.startDate,
                                          minDate: _vm.WeekModel.validFrom,
                                          maxDate: _vm.WeekModel.validUntil,
                                          label: _vm.$t("firstBookingDate"),
                                          allowedDates: _vm.allowedDates,
                                          disabled: _vm.WeekModel.locked,
                                        },
                                        on: {
                                          dateChange: function ($event) {
                                            _vm.WeekModel.friday.startDate =
                                              $event
                                          },
                                          monthChanged: function ($event) {
                                            return _vm.setAllowedDates(
                                              5,
                                              _vm.WeekModel.friday.type,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    staticStyle: { "max-width": "460px" },
                                    attrs: {
                                      label: _vm.$t("saturday"),
                                      readonly: "",
                                      disabled: _vm.WeekModel.locked,
                                      "append-icon": "mdi-pencil",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showAutoDailyModel = true
                                        _vm.selectedDay = "saturday"
                                      },
                                    },
                                    model: {
                                      value: _vm.WeekModel.saturday.workTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.saturday,
                                          "workTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.saturday.workTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.rhythmTypes,
                                      disabled: _vm.WeekModel.locked,
                                    },
                                    model: {
                                      value: _vm.WeekModel.saturday.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.saturday,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.saturday.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.WeekModel.saturday.type != 0
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("DatePicker", {
                                        key: _vm.WeekModel.saturday.startDate,
                                        attrs: {
                                          date: _vm.WeekModel.saturday
                                            .startDate,
                                          minDate: _vm.WeekModel.validFrom,
                                          maxDate: _vm.WeekModel.validUntil,
                                          label: _vm.$t("firstBookingDate"),
                                          allowedDates: _vm.allowedDates,
                                          disabled: _vm.WeekModel.locked,
                                        },
                                        on: {
                                          dateChange: function ($event) {
                                            _vm.WeekModel.saturday.startDate =
                                              $event
                                          },
                                          monthChanged: function ($event) {
                                            return _vm.setAllowedDates(
                                              6,
                                              _vm.WeekModel.saturday.type,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    staticStyle: { "max-width": "460px" },
                                    attrs: {
                                      label: _vm.$t("sunday"),
                                      readonly: "",
                                      disabled: _vm.WeekModel.locked,
                                      "append-icon": "mdi-pencil",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showAutoDailyModel = true
                                        _vm.selectedDay = "sunday"
                                      },
                                    },
                                    model: {
                                      value: _vm.WeekModel.sunday.workTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.sunday,
                                          "workTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.sunday.workTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.rhythmTypes,
                                      disabled: _vm.WeekModel.locked,
                                    },
                                    model: {
                                      value: _vm.WeekModel.sunday.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel.sunday,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.sunday.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.WeekModel.sunday.type != 0
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("DatePicker", {
                                        key: _vm.WeekModel.sunday.startDate,
                                        attrs: {
                                          date: _vm.WeekModel.sunday.startDate,
                                          minDate: _vm.WeekModel.validFrom,
                                          maxDate: _vm.WeekModel.validUntil,
                                          label: _vm.$t("firstBookingDate"),
                                          allowedDates: _vm.allowedDates,
                                          disabled: _vm.WeekModel.locked,
                                        },
                                        on: {
                                          dateChange: function ($event) {
                                            _vm.WeekModel.sunday.startDate =
                                              $event
                                          },
                                          monthChanged: function ($event) {
                                            return _vm.setAllowedDates(
                                              0,
                                              _vm.WeekModel.sunday.type,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.WeekModel.validFrom != null &&
                  _vm.WeekModel.validUntil != null
                    ? _c("v-textarea", {
                        staticClass: "pb-2",
                        attrs: {
                          name: "input-7-1",
                          label: _vm.$t("remark"),
                          counter: 254,
                          rules: _vm.remarkRules,
                        },
                        model: {
                          value: _vm.WeekModel.commit,
                          callback: function ($$v) {
                            _vm.$set(_vm.WeekModel, "commit", $$v)
                          },
                          expression: "WeekModel.commit",
                        },
                      })
                    : _vm._e(),
                  _vm.WeekModel.validFrom != null &&
                  _vm.WeekModel.validUntil != null
                    ? _c(
                        "v-layout",
                        { attrs: { "align-center": "", "justify-center": "" } },
                        [
                          !_vm.saveMode
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: _vm.logicError,
                                    color: "primary",
                                  },
                                  on: { click: _vm.addWeekModel },
                                },
                                [_vm._v(_vm._s(_vm.$t("addWeeklyModel")))]
                              )
                            : _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", color: "primary" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  directives: [
                                                    {
                                                      name: "ripple",
                                                      rawName: "v-ripple",
                                                    },
                                                  ],
                                                  attrs: {
                                                    disabled: _vm.logicError,
                                                    color: "primary",
                                                  },
                                                  on: {
                                                    click: _vm.saveWeekModel,
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("saveWeeklyModel")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2297033815
                                  ),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "textColor--text" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("autoModelChangeWarning")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showAutoDailyModel
        ? _c("AutoDailyModel", {
            attrs: { dayPeriods: _vm.WeekModel[_vm.selectedDay].periods },
            on: {
              close: function ($event) {
                _vm.showAutoDailyModel = false
              },
              addAutoDayModel: _vm.addAutoDayModel,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }